export { default as DiscoveryPanel } from './DiscoveryPanel';
